import { personActions } from "./person";

export const persons_action = {
  ...personActions,
};
export { default as personSlices } from "./person";
